import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useLocation, useNavigate } from "react-router";

const steps = ["Scope", "Ownership", "Site audit"];

export default function MannualSteps({ activeStep, ownerId, create, update, isVerified }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isCreateRoute = location.pathname === "/project-config/create";
  const stepsBox = {
    width: "100%",
    "& .MuiStepConnector-line": {
      borderTopStyle: "dotted",
      borderWidth: "3px",
      borderColor: "#757575",
      pointerEvents: "none",
    },

    "& .MuiStepConnector-root": {
      top: "15px",
      pointerEvents: "none",
    },
    "& .MuiStepButton-root": {
      pointerEvents: "none",
      "&:focus": {
        outline: "none",
        border: "none",
      },
    },
    "& .MuiStepLabel-root": {
      pointerEvents: "none",
    },
    "& .MuiStep-root": {
      "&:nth-child(2)": {
        "& .MuiStepLabel-iconContainer": {
          cursor: update && "pointer",
        },
      },
      "&:nth-child(3)": {
        "& .MuiStepLabel-iconContainer": {
          cursor: isVerified && "pointer",
        },
      },
    },
    "& .MuiStepLabel-iconContainer": {
      pointerEvents: "auto",
    },
    "& .MuiStepLabel-alternativeLabel": {
      marginTop: "2px !important",
    },
    "& .Mui-active": {
      color: "#45C0CB !important",
      cursor: isCreateRoute ? "default" : "pointer",
      "& .MuiStepConnector-line": {
        borderColor: "#45C0CB",
      },
    },
    "& .Mui-completed": {
      color: "#45C0CB !important",
      "& .Mui-completed": {
        cursor: isCreateRoute ? "default" : "pointer",
      },
      "& .MuiStepConnector-line": {
        borderColor: "#45C0CB",
      },
    },
  };

  const handleClick = label => {
    if (isCreateRoute) return;
    if (create && activeStep === 1) {
      if (label === "Scope" && activeStep !== 0) {
        navigate(`/project-config/update/${ownerId}`);
        return;
      }
    }
    if (create) {
      return;
    }
    if (label === "Scope" && activeStep !== 0) {
      navigate(`/project-config/update/${ownerId}`);
    }
    if (label === "Ownership" && activeStep !== 1) {
      navigate(`/project-config/${ownerId}`);
    }
    if (label === "Site audit" && activeStep !== 2 && isVerified) {
      navigate(`/project-config/site/${ownerId}`);
    }
  };
  return (
    <Box sx={stepsBox} onClick={handleClick}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map(label => (
          <Step key={label}>
            <StepLabel className="activeStep" onClick={isCreateRoute ? undefined : () => handleClick(label)}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
